/**
 * Option gallery — client-side filter + click-to-select into the builder.
 * Generic successor of figurine-gallery.js: serves every grouped option the
 * Bridge builder flags (figurine, 2 inch stock inserts, column style, …).
 *
 * The grid is server-rendered by Bridge (GET /quick-view/option-gallery) into
 * #optionGalleryBody, so this file has NO transport of its own:
 *
 *  1. Filters the tiles by the `keywords` attribute Bridge stamps on each
 *     .option-gallery-item (group + style + sku). Section visibility is decided
 *     from a per-section MATCH TALLY, never from `:visible` — items inside a
 *     hidden section are `:hidden` regardless of their own display, so a
 *     :visible check goes stale after any zero-result search and sections
 *     would never come back.
 *  2. A tile click selects that option in the product options. Grouped
 *     attributes post BOTH values in the one builder re-render the style
 *     select's own change would trigger (set group select + hidden style
 *     input, fire button.btn-builder with ?builder=true&sku&step&is_group=0,
 *     the same link the templates' change handler builds). Flat attributes
 *     (no group select, e.g. neck ribbons) set their own select directly and
 *     fire its change.
 *  3. Scroll management: every gallery shares one modal whose scroll container
 *     (.option-gallery-modal-body) sits OUTSIDE the injected body, so its
 *     scrollTop would otherwise leak between galleries. On every body
 *     injection (MutationObserver — content arrival, nothing else) the scroll
 *     resets to top, then centres the .is-selected tile when one exists.
 *
 * Delegated because everything is injected into the modal after load.
 */
window.myjQuery(document).ready(function ($) {

  function scrollContainer() {
    return document.querySelector('#optionGalleryModal .option-gallery-modal-body');
  }

  // Reset to top; centre the selected tile when reopening a gallery that has
  // a current selection. Rect math, not scrollIntoView — scrollIntoView can
  // drag the page behind the modal along.
  function applyGalleryScroll() {
    var cont = scrollContainer();

    if (!cont) {
      return;
    }

    cont.scrollTop = 0;

    var tile = document.querySelector('#optionGalleryBody .option-gallery-item.is-selected');

    if (!tile) {
      return;
    }

    var tileRect = tile.getBoundingClientRect();
    var contRect = cont.getBoundingClientRect();

    if (!contRect.height) {
      return; // container not laid out (modal hidden) — nothing to scroll.
    }

    cont.scrollTop += tileRect.top - contRect.top - (contRect.height / 2) + (tileRect.height / 2);
  }

  var galleryBody = document.getElementById('optionGalleryBody');

  if (galleryBody && window.MutationObserver) {
    // Fires when turbo fills the body. jQuery runs the ajax done/always
    // callbacks synchronously, so by the time this microtask runs the
    // .modal-dialog-live region is visible again and rects are valid.
    new MutationObserver(applyGalleryScroll).observe(galleryBody, { childList: true });
  }

  $('body').on('input', '.option-gallery-search', function () {

    var term = $(this).val().trim().toLowerCase();
    var $gallery = $(this).closest('.option-gallery');
    var total = 0;

    $gallery.find('.option-gallery-section').each(function () {
      var matches = 0;

      $(this).find('.option-gallery-item').each(function () {
        var keywords = ($(this).attr('keywords') || '').toLowerCase();
        var match = !term.length || keywords.indexOf(term) !== -1;
        $(this).toggle(match);
        if (match) {
          matches++;
        }
      });

      $(this).toggle(matches > 0);
      total += matches;
    });

    $gallery.find('.option-gallery-noresults').toggle(total === 0);

    // Results start above the fold even if the customer had scrolled deep.
    var cont = scrollContainer();
    if (cont) {
      cont.scrollTop = 0;
    }
  });

  $('body').on('click', '#optionGalleryBody .option-gallery-select', function () {

    // .attr() not .data(): jQuery .data() would coerce a numeric-looking group
    // or sku ("2024") into a number, and the group must match its <option> text.
    var sku = $(this).attr('data-sku');
    var attribute = $(this).attr('data-attribute');
    var group = $(this).attr('data-group');
    var value = $(this).attr('data-value');

    var $form = $('form#builders');
    var styleName = 'builders[' + sku + '][attributes][' + attribute + ']';
    var $group = $form.find('select[name="builders[' + sku + '][attributes][group_' + attribute + ']"]');

    // FLAT attribute (no group select, e.g. neck ribbons): the option lives in
    // the attribute's own select — set it and let the templates' existing
    // .builder-dropdown change handler do the normal re-render.
    if (!$group.length) {
      var $flat = $form.find('select[name="' + styleName + '"]');

      if (!$flat.length) {
        return;
      }

      $flat.val(value);
      $('#optionGalleryModal').modal('hide');
      $flat.trigger('change');
      return;
    }

    $group.val(group);

    // Replace whatever holds the style today (the style select from an earlier
    // pick, or a hidden input from an earlier gallery click). The re-render
    // rebuilds the real select with this value selected.
    $form.find('[name="' + styleName + '"]').remove();
    $('<input type="hidden">').attr('name', styleName).val(value).appendTo($form);

    // Same link the templates' .builder-dropdown change handler builds for the
    // style select: is_group=0 so the NEXT step is enabled after this render.
    var link = $group.data('link') + '?builder=true&sku=' + sku + '&step=' + $group.data('step') + '&is_group=0';

    // Group pages need category_id (grouped() does Category::find); the
    // template appends it from Liquid, we read it off the options loader link.
    var loader = String($('.btn-get-options').data('link') || '');
    var category = loader.match(/[?&]category_id=(\d+)/);
    if (category) {
      link += '&category_id=' + category[1];
    }

    var $submit = $('button.btn-builder');
    $submit.data('link', link);
    $submit.data('show', '.spinner-dropdown-' + attribute + '-' + sku + '-group');

    $('#optionGalleryModal').modal('hide');
    $submit.click();
  });

});
